import { Component, Input, ViewChild, ElementRef } from '@angular/core';
 
@Component({
  selector: 'expandable',
  templateUrl: 'expandable.html'
})
export class ExpandableComponent {
 
    @ViewChild('expandWrapper', {read: ElementRef}) expandWrapper;
    @Input('expanded') expanded;
    @Input('expandHeight') expandHeight;
 
    constructor() {
 
    }
 
    ngAfterViewInit(){
        // this.renderer.setElementStyle(this.expandWrapper.nativeElement, 'height', this.expandHeight + 'px');   
        // console.log(this.expandHeight);
    }

 
}


// WEBPACK FOOTER //
// ./src/components/expandable/expandable.ts